import React from "react";
import { Store } from "redux";
import { useSelector } from "react-redux";
import { getActiveBets } from "@urp/lib-racetracks/src/redux/selectors";
import { useURPProgramPageOnXSell } from "@urp/amplitude-experiments";
import { get } from "lodash";
import {
  getRacePromos,
  hasRacePromoCPP,
  hasRacePromoCPPOptedIn
} from "@urp/lib-racetracks/src/utils/races";
import {
  getCPPPromos,
  getIsLogged,
  getOptedInPromos
} from "@urp/store-selectors";
import { buildQaLabel } from "@tvg/test-utils/utils";
import { HighlightedStyle } from "@tvg/ts-types/Race";
import getMostRelevantPromo from "@tvg/utils/PromoUtils";
import { Container } from "./styled-components";
import { type RaceIconProps } from "./types";
import { renderOtherIcons, renderVideoIcons } from "./renderer";
import { CONTAINER, ICONS } from "../../utils/constants";

export const RaceIcons = ({ race, qaLabel = "" }: RaceIconProps) => {
  const optedInPromos = useSelector(getOptedInPromos);
  const cppPromos = useSelector(getCPPPromos);
  const isLogged = useSelector(getIsLogged);
  const shouldUseUrpPPonXSell = useURPProgramPageOnXSell();
  const activeBets = useSelector((store: Store) =>
    getActiveBets(store, shouldUseUrpPPonXSell)
  );

  const isHighlighted =
    race?.highlighted?.style === HighlightedStyle.Highlighted;
  const availablePromos = getRacePromos(race);
  const mostRelevantPromo = getMostRelevantPromo(
    availablePromos,
    optedInPromos,
    isLogged
  );
  const isOptedIn = !!mostRelevantPromo?.isOptedIn;
  const hasPromosAvailable = !!mostRelevantPromo;
  const hasCPPPromoAvailable = hasRacePromoCPP(cppPromos, race);
  const isCPPPromosOptedIn = hasRacePromoCPPOptedIn(cppPromos, race, isLogged);
  const hasActiveBets = get(activeBets, race?.tvgRaceId ?? "", 0);
  const lineColor = isHighlighted
    ? "--fd-colors-content-on-dark"
    : "--fd-colors-content-subtle";
  const brandColor = isHighlighted ? "white" : "grey";
  const promoLineColor = isHighlighted
    ? "--fd-colors-system-alert-background-default"
    : "--fd-colors-system-alert-content-accent";

  const promoBackgroundColor = isHighlighted
    ? "--fd-colors-core-yellow-d-3"
    : "--fd-colors-system-alert-background-subtle";

  const video = get(race, "video");
  const code = get(race, "status.code");

  return (
    <Container data-qa-label={buildQaLabel([qaLabel, ICONS, CONTAINER])}>
      {renderOtherIcons(
        isLogged,
        isOptedIn || isCPPPromosOptedIn,
        hasPromosAvailable || hasCPPPromoAvailable,
        hasActiveBets,
        lineColor,
        promoLineColor,
        promoBackgroundColor,
        qaLabel
      )}
      {renderVideoIcons(video, code, lineColor, brandColor, qaLabel)}
    </Container>
  );
};
